import React, { useEffect, useMemo, useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import './style.css';

const SelectComplex = ({ options, name, onSelectionChange, selectedValues, formError, label, lang, field, field_second, na_text, className = "col-md-6" }) => {
    // console.log(selectedValues)
    const [selected, setSelected] = useState([]);
    const transformOption = (option) => {
        const primaryLabel = lang && option[field] && option[field][lang]
            ? option[field][lang]
            : option[field] || "Unknown";

        const secondaryLabel = field_second && option[field_second]
            ? option[field_second]
            : na_text;

        const combinedLabel = field_second && option[field_second]
            ? `${primaryLabel} - ${secondaryLabel}`
            : primaryLabel;

        return {
            id: option.id,
            value: option.id,
            label: combinedLabel
        };
    };

    const transformedOptions = useMemo(() => options.map(transformOption), [options, lang, field]);
    useEffect(() => {
        const selectedOption = transformedOptions.find(option => option.id === selectedValues);
        if (selectedOption) {
            setSelected([selectedOption]);
        }
    }, [selectedValues, transformedOptions]);

    const handleSelectionChange = (newSelection) => {
        const selectedOptions = newSelection.length > 0 ? [newSelection[newSelection.length - 1]] : [];
        const event = {
            target: {
                name: name,
                value: selectedOptions?.[0]?.id,
            },
        };
        setSelected(selectedOptions);
        onSelectionChange(event);
    };

    return (
        <div className={className}>
            <label className="form-label">
                {label}
            </label>
            {/* <div>
                <ShowMoreComponent items={selected.map(obj => obj.label)} maxVisible={5} />
            </div> */}
            <MultiSelect
                options={transformedOptions}
                value={selected}
                onChange={handleSelectionChange}
                labelledBy="Select"
                name={name}
                className="multi-select-container"
                hasSelectAll={false}
                style={{
                    zIndex: 9999, // dropdown'un yukarıda görünmesi için
                }}
            />
            {formError?.[name] && formError[name]?.length > 0 && (
                <div className="invalid-feedback" style={{ display: 'block', color: 'red', marginTop: '5px' }}>
                    {formError[name].map((error, index) => (
                        <div key={index}>{error}</div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SelectComplex;
